import styled, { css } from 'styled-components';
import { FontWeight } from 'components/Text';
import Colors from 'constants/Colors';

export const ModalContainer = styled.div`
  position: fixed; 
  z-index: 999; 
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto; 
  background-color: rgba(255,255,255,0.4);
  ${({ show }) => show ? css`display: block;` : `display: none;`}
`;

export const Content = styled.div`
position: absolute;
z-index: 5;
background: ${Colors.WHITE};
color: ${Colors.BLACK};
background: #FFF;
font-weight: 500;
font-size: 16px;
border: none;
margin: 20vh 10vw;
box-shadow: 0px 17px 17px 6px #5f5f5f1a;
padding: 25px 35px;
`;

export const Header = styled.div`
  background: ${Colors.GREEN};
  color: ${Colors.WHITE};
  padding: 10px 20px;
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 18px;
  display:flex;
  justify-content: space-between;
  text-transform: uppercase;
  border-radius: 15px 15px 0px 0px;
  margin: -10px -10px 0px -10px;
`;

export const Scrollbox = styled.div` 
  overflow-y: auto;
  overflow-x: hidden;
  height: auto;
  
  ::-webkit-scrollbar{
    background:${Colors.WHITE};
    width:8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
  `;
